import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import { faListUl } from '@fortawesome/pro-solid-svg-icons';
import { faBriefcase } from '@fortawesome/pro-solid-svg-icons';

const OverlayButton = ({ children, iconClass, hide, onOpen, onClose, rootClose = true, useNewIcon = false }) => {
  if (!children) return null;

  const overlayRef = useRef(null);

  useEffect(() => {
    if (hide) overlayRef.current.hide();
  }, [hide]);

  const columnsPopover = (
    <Popover id="popover-positioned-bottom">
      {children}
    </Popover>
  );

  return (
    <div className="clickable">
      <OverlayTrigger
        overlay={columnsPopover}
        placement="bottom"
        ref={overlayRef}
        rootClose={rootClose}
        trigger="click"
        onEnter={onOpen}
        onExit={onClose}
      >
        <FontAwesomeIcon
          className={classNames('folder-icon', iconClass)}
          icon={useNewIcon ? faBriefcase : faListUl}
        />
      </OverlayTrigger>
    </div>
  );
};

OverlayButton.propTypes = {
  children: PropTypes.object,
  hide: PropTypes.bool,
  iconClass: PropTypes.string,
  rootClose: PropTypes.bool,
  useNewIcon: PropTypes.bool,
  onClose: PropTypes.func,
  onOpen: PropTypes.func
};

export default OverlayButton;
